import { Star, ExternalLink } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';

export default function GoogleReviews() {
  return (
    <section className="pt-20 lg:pt-28 pb-8 lg:pb-12 relative overflow-hidden">
      {/* POZADINA SA NAMEŠTAJEM */}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-gradient-to-b from-background via-secondary/20 to-background" />
        
        {/* Blur-ovane slike nameštaja */}
        <div className="absolute top-20 left-10 w-[420px] h-[420px] opacity-10">
          <img 
            src="https://images.unsplash.com/photo-1555041469-a586c61ea9bc?q=80&w=800" 
            alt=""
            className="w-full h-full object-cover rounded-3xl"
            style={{ filter: 'blur(16px)' }}
          />
        </div>
        
        <div className="absolute bottom-20 right-10 w-[380px] h-[380px] opacity-8">
          <img 
            src="https://images.unsplash.com/photo-1604578762246-41134e37f9cc?q=80&w=800" 
            alt=""
            className="w-full h-full object-cover rounded-3xl"
            style={{ filter: 'blur(18px)' }}
          />
        </div>
      </div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        {/* Google Reviews Header */}
        <div className="max-w-5xl mx-auto">
          {/* Main Reviews Card - SAMO OVAJ KARTON */}
          <Card className="border-2 border-border/50 bg-card/95 backdrop-blur-sm shadow-2xl">
            <CardContent className="p-8 lg:p-12">
              <div className="flex flex-col lg:flex-row items-center justify-between gap-8">
                {/* Left - Google Rating */}
                <div className="flex-1 text-center lg:text-left">
                  <div className="flex items-center justify-center lg:justify-start gap-3 mb-4">
                    <div className="w-16 h-16 bg-white rounded-lg shadow-md flex items-center justify-center">
                      <svg viewBox="0 0 24 24" className="w-10 h-10">
                        <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
                        <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
                        <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
                        <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
                      </svg>
                    </div>
                    <div>
                      <div className="text-sm font-medium text-muted-foreground mb-1">Google recenzije</div>
                      <div className="flex items-center gap-2">
                        <span className="text-5xl font-bold text-foreground">4.7</span>
                        <div className="flex flex-col">
                          <div className="flex gap-0.5">
                            {[1, 2, 3, 4, 5].map((star) => (
                              <Star 
                                key={star} 
                                className={`w-5 h-5 ${
                                  star <= 4 
                                    ? 'fill-[#FBBC04] text-[#FBBC04]' 
                                    : star === 5 
                                    ? 'fill-[#FBBC04] text-[#FBBC04] opacity-60'
                                    : 'text-gray-300'
                                }`}
                              />
                            ))}
                          </div>
                          <span className="text-xs text-muted-foreground mt-1">28+ recenzija</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <p className="text-muted-foreground text-sm lg:text-base">
                    Ocena na osnovu autentičnih Google recenzija naših kupaca
                  </p>
                </div>

                {/* Right - CTA */}
                <div className="flex-shrink-0">
                  <Button
                    size="lg"
                    className="bg-[#4285F4] hover:bg-[#3367D6] text-white font-medium px-8 py-6 shadow-lg hover:shadow-xl transition-all duration-300 group"
                    onClick={() => window.open('https://www.google.com/search?sxsrf=ANbL-n5-6Xw5bfeeImnFTDDp4wqxH83cWg:1768239147323&si=AL3DRZEsmMGCryMMFSHJ3StBhOdZ2-6yYkXd_doETEE1OR-qOUwIi5HibyFMAOdtaveSVV79lr1QlEBunaqJG3saAWls4y-L0nojpvLMdd4ZpISf-08MvOKh2DWR7GlZlcCmprV-YCjG&q=Name%C5%A1taj+Sanin+Reviews&aic=0', '_blank')}
                  >
                    Pogledaj sve recenzije
                    <ExternalLink className="ml-2 w-5 h-5 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
                  </Button>
                </div>
              </div>
            </CardContent>
          </Card>

          {/* Trust Badge */}
          <div className="mt-12 lg:mt-16 text-center">
            <div className="inline-flex items-center gap-3 px-8 py-4 bg-card/90 backdrop-blur-sm rounded-full border-2 border-border/50 shadow-md">
              <svg viewBox="0 0 24 24" className="w-6 h-6">
                <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
                <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
                <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
                <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
              </svg>
              <span className="text-sm lg:text-base font-medium text-muted-foreground">
                Verifikovano na Google Maps
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
